<!--
 * @description: 自然博物馆
 * @Author: Jay
 * @Date: 2021-10-13 10:50:37
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-16 15:42:44
-->
<template>
  <div>
    <!-- 顶部 背景 标题 -->
    <bg-img-top
      :bgImg="$api + reData.image"
      EnTitle="Science museum"
      title="自然科普馆"
      v-if="reData != ''"
    ></bg-img-top>
    <!-- 页面内容 -->
    <div class="fix-width" v-if="reData != ''">
      <div class="margin-top">
        <!-- 商品列表 -->
        <goods-code
          id="0"
          title="自然科普馆"
          name="Science museum"
          :tabList="reData.data"
          :tabID="seleId"
        ></goods-code>
      </div>
      <!-- 分页 -->
      <!-- <div class="margin-top text-align">
        <el-pagination background layout="prev, pager, next" :total="10">
        </el-pagination>
      </div> -->
    </div>
    <!-- 底部边距 -->
    <div class="margin-top margin-bottom"></div>
  </div>
</template>

<script>
// 顶部 背景 标题
import bgImgTop from "@/components/tab/bg-img-top.vue";
// 商品列表
import goodsCode from "@/components/carousel/goods-code.vue";
import { getSample } from "../../api/api";
export default {
  name: "NatureCoupe",
  data() {
    return {
      //请求数据
      reData: [],
      //子组件 tab  index
      seleId: 0,
    };
  },
  components: {
    bgImgTop,
    goodsCode,
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 自然博物馆
      getSample().then((res) => {
        // console.log(res);
        this.reData = res.data;
      });
    },
  },
  watch: {
    // 监听路由 值
    "$route.query.index"(newval) {
      // console.log("监听路由 值", newval, olval);
      // 切换选中状态
      this.seleId = newval;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>